import type { Route, RouteConfig } from 'vue-router'
import { isAuthorized, lazyLoadView, piloteAndAuditor } from '@/router/routing'
import MainContent from '@/components/layout/MainContent.vue'
import {
  ORGANIZATION_ROUTE_NAME,
  ORGANIZATION_TREE_ROUTE_NAME,
  ORGANIZATION_PERIMETERS_LIST_ROUTE_NAME,
  ORGANIZATION_FILTERED_ROUTE_NAME,
} from '@/contexts/organization/Organization.constants'
import { FeatureFlag } from '@/contexts/shared/feature-flags/FeatureFlags.interfaces'

const organizationRouteMeta = {
  i18nTitle: 'organization.menu.title',
  icon: 'sitemap',
  is_authorized: (route: Route) => isAuthorized(route),
  requires_auth: true,
  requires_tenant: true,
  requires_role: piloteAndAuditor,
  doc_id: 'organization',
  feature_id: 'SECURITY_BASE',
}

const organizationViewMeta = {
  ...organizationRouteMeta,
  hasNeutralContentBackground: true,
}

export const organizationRoutes: RouteConfig = {
  path: '/organization',
  name: ORGANIZATION_ROUTE_NAME,
  component: MainContent,
  redirect: { name: ORGANIZATION_TREE_ROUTE_NAME },
  meta: organizationRouteMeta,
  children: [
    {
      path: 'tree',
      name: ORGANIZATION_TREE_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/organization/OrganizationTreeView.vue')),
      meta: organizationRouteMeta,
    },
    {
      path: 'list',
      name: ORGANIZATION_PERIMETERS_LIST_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/organization/OrganizationListView.vue')),
      meta: {
        ...organizationViewMeta,
        requires_feature_flag: FeatureFlag.ORGANIZATION_PERIMETERS_GROUP_BY,
      },
    },
    {
      path: 'filtered/list',
      name: ORGANIZATION_FILTERED_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/organization/OrganizationFilteredView.vue')),
      meta: {
        i18nTitle: 'organization.menu.advanced_filter',
        icon: 'stream',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'filtered_perimeter',
      },
    },
  ],
}
